export function RejectedJobsPage() {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">Rejected Jobs</h1>
      <p className="mt-2 text-gray-600">Jobs you're not interested in</p>
      {/* Rejected jobs implementation will go here */}
    </div>
  );
}